import * as LocalStorageService from './LocalStorageService';

const VALUE_EXPIRATION_DAYS = 7;

export const saveAdviceSubmitted = () => {
  const currentDate = new Date();
  LocalStorageService.setAdviceSubmittedDate(currentDate.getTime());
};

export function adviceSubmitted() {
  const valueDate = LocalStorageService.getAdviceSubmittedDate();
  const currentDate = new Date();
  const timeDiff = Math.abs(currentDate.getTime() - valueDate);
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return diffDays < VALUE_EXPIRATION_DAYS;
}
